import { FC } from "react";
import style from "./style.module.scss";
import { DAY_TYPE_COLORS } from "../../utils/dayTypes";

type Props = {
  // Special Days has no villa context, so it has nothing to say about
  // maintenance or existing bookings — those entries are hidden there.
  showMaintenance?: boolean;
  showBooked?: boolean;
};

// Colour key for the date pickers, in the same order the app calendar lists its
// tags: a swatch per day-type and what it means, nothing more.
const DayTypeLegend: FC<Props> = ({
  showMaintenance = true,
  showBooked = true,
}) => (
  <div className={style.legend}>
    <span className={style.item}>
      <i style={{ background: DAY_TYPE_COLORS.high_peak }} />
      High Peak
    </span>
    <span className={style.item}>
      <i style={{ background: DAY_TYPE_COLORS.peak }} />
      Peak
    </span>
    {showMaintenance && (
      <span className={style.item}>
        <i style={{ background: DAY_TYPE_COLORS.maintenance }} />
        Maintenance
      </span>
    )}
    {showBooked && (
      <span className={style.item}>
        <i style={{ background: DAY_TYPE_COLORS.booked }} />
        {/* booked days carry no colour of their own — they are struck through */}
        <s>Booked</s>
      </span>
    )}
  </div>
);

export default DayTypeLegend;
